import { render } from "./pieChart3.vue?vue&type=template&id=0e94417f&scoped=true"
import script from "./pieChart3.vue?vue&type=script&lang=js"
export * from "./pieChart3.vue?vue&type=script&lang=js"

import "./pieChart3.vue?vue&type=style&index=0&id=0e94417f&scoped=true&lang=css"

import exportComponent from "E:\\ddemo\\zhongxiaoqi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e94417f"]])

export default __exports__